import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { environment } from 'environments/environment';
import { FormGroup, FormControl, Validators } from '@angular/forms';

interface LocalAd{
  link: string,
  imagePath: any,
  locationOfAd: string,
  page: string
}

@Component({
  selector: 'app-edit-local-ads',
  templateUrl: './edit-local-ads.component.html',
  styleUrls: ['./edit-local-ads.component.css']
})
export class EditLocalAdsComponent {

  positions = [
    {value: 'first-box', viewValue: 'First Box'},
    {value: 'second-box', viewValue: 'Second Box'},
    {value: 'third-box', viewValue: 'Third Box'}
  ]

  pages = [
    {value: 'home', viewValue: 'Home Page'},
    {value: 'property', viewValue: 'Property Page'},
    {value: 'search', viewValue: 'Search Page'}
  ]

  advertisementForm = new FormGroup({
    link: new FormControl('', [Validators.required]),
    locationOfAd: new FormControl('', [Validators.required]),
    page: new FormControl('', [Validators.required]),
    imagePath: new FormControl(null)
  })

  constructor(
    public dialogRef: MatDialogRef<EditLocalAdsComponent>,
    @Inject(MAT_DIALOG_DATA) public data: LocalAd) {
      let advertisementInstance = Object.assign({}, data)
      this.advertisementForm.setValue(advertisementInstance)
    }

  onNoClick(): void {
    this.dialogRef.close();
  }

  fileChangeEvent(event: any){
    let image = event.target.files[0]
    this.advertisementForm['controls']['imagePath'].setValue(image)
    var reader = new FileReader();
    reader.readAsDataURL(event.target.files[0]); 
    reader.onload = (_event) => { 
      this.data.imagePath = reader.result; 
    }
  }

  saveAd(){
    if(this.advertisementForm.valid){
      this.dialogRef.close(this.advertisementForm.value)
    }
  }

}